import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译文件
import zhCN from './translations/zh-CN';
import zhTW from './translations/zh-TW';
import enUS from './translations/en-US';
import ruRU from './translations/ru-RU';
import jaJP from './translations/ja-JP';
import koKR from './translations/ko-KR';
import thTH from './translations/th-TH';

// 支持的语言列表
export const supportedLocales = {
  'zh-CN': {
    name: '简体中文',
    nativeName: '简体中文',
    flag: '🇨🇳'
  },
  'zh-TW': {
    name: '繁體中文',
    nativeName: '繁體中文',
    flag: '🇹🇼'
  },
  'en-US': {
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸'
  },
  'ru-RU': {
    name: 'Русский',
    nativeName: 'Русский',
    flag: '🇷🇺'
  },
  'ja-JP': {
    name: '日本語',
    nativeName: '日本語',
    flag: '🇯🇵'
  },
  'ko-KR': {
    name: '한국어',
    nativeName: '한국어',
    flag: '🇰🇷'
  },
  'th-TH': {
    name: 'ไทย',
    nativeName: 'ไทย',
    flag: '🇹🇭'
  }
};

// 翻译资源
const resources = {
  'zh-CN': { translation: zhCN },
  'zh-TW': { translation: zhTW },
  'en-US': { translation: enUS },
  'ru-RU': { translation: ruRU },
  'ja-JP': { translation: jaJP },
  'ko-KR': { translation: koKR },
  'th-TH': { translation: thTH }
};

// 初始化 i18n
i18n
  .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 绑定 React
  .init({
    resources,
    
    // 默认语言
    fallbackLng: 'zh-CN',
    
    // 调试模式（生产环境应设为 false）
    debug: process.env.NODE_ENV === 'development',
    
    // 语言检测配置
    detection: {
      // 检测顺序：localStorage -> navigator -> fallback
      order: ['localStorage', 'navigator'],
      
      // localStorage 键名
      lookupLocalStorage: 'i18nextLng',
      
      // 缓存用户选择的语言
      caches: ['localStorage'],
      
      // 排除某些路径的语言检测
      excludeCacheFor: ['cimode']
    },
    
    // 插值配置
    interpolation: {
      // React 已经默认转义了，不需要额外转义
      escapeValue: false,
      
      // 格式化函数
      format: function(value, format, lng) {
        if (format === 'number') {
          return new Intl.NumberFormat(lng).format(value);
        }
        if (format === 'currency') {
          return new Intl.NumberFormat(lng, {
            style: 'currency',
            currency: 'CNY'
          }).format(value);
        }
        if (format === 'date') {
          return new Intl.DateTimeFormat(lng).format(new Date(value));
        }
        if (format === 'datetime') {
          return new Intl.DateTimeFormat(lng, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          }).format(new Date(value));
        }
        return value;
      }
    },
    
    // React 特定配置
    react: {
      // 使用 Suspense 进行异步加载
      useSuspense: false,
      
      // 绑定事件
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      
      // 转义模式
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span']
    }
  });

// 导出工具函数
export const getCurrentLanguage = () => i18n.language;

export const changeLanguage = (lng) => {
  return i18n.changeLanguage(lng);
};

export const isRTL = (lng = i18n.language) => {
  // 目前支持的语言都是从左到右，如果以后支持阿拉伯语等需要修改
  return false;
};

export const getLanguageDirection = (lng = i18n.language) => {
  return isRTL(lng) ? 'rtl' : 'ltr';
};

export default i18n;
